import React, { useEffect, useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

const API_URL = (
  process.env.REACT_APP_API_URL || "https://api.bsangam.com"
)
  .replace(/\/uploads\/?$/, "")
  .replace(/\/$/, "");

const getUploadUrl = (file?: string | null) => {
  if (!file || String(file).trim() === "") {
    return "/assets/images/user.png";
  }

  const value = String(file).trim();

  if (value.startsWith("http://") || value.startsWith("https://")) {
    return encodeURI(value);
  }

  if (value.startsWith("/uploads/")) {
    return encodeURI(`${API_URL}${value}`);
  }

  if (value.startsWith("uploads/")) {
    return encodeURI(`${API_URL}/${value}`);
  }

  if (value.startsWith("/")) {
    return encodeURI(`${API_URL}${value}`);
  }

  return encodeURI(`${API_URL}/uploads/${value}`);
};

const mainItems = [
  {
    to: "/home",
    label: "Home",
    icon: "feather-home",
  },
  {
    to: "/defaultvideo",
    label: "Videos",
    icon: "feather-video",
  },
  {
    to: "/clubs",
    label: "Clubs",
    icon: "feather-users",
  },
  {
    to: "/contacts",
    label: "Contacts",
    icon: "feather-user-check",
  },
];

const moreItems = [
{
  to: "/defaultstorie",
  label: "Trending News",
  icon: "feather-trending-up",
},
  {
    to: "/matrimony/profile",
    label: "Matrimony",
    icon: "feather-heart",
  },
  {
    to: "/users",
    label: "Connects",
    icon: "feather-user",
  },
  {
    to: "/clubs-map",
    label: "Club Map",
    icon: "feather-map-pin",
  },
];

const Appfooter: React.FC = () => {
  const location = useLocation();
  const [showMore, setShowMore] = useState(false);

  const [currentUser, setCurrentUser] = useState<any>(() =>
    JSON.parse(localStorage.getItem("user") || "{}"),
  );

  useEffect(() => {
    const refreshUser = () => {
      setCurrentUser(JSON.parse(localStorage.getItem("user") || "{}"));
    };

    window.addEventListener("userProfileUpdated", refreshUser);
    window.addEventListener("storage", refreshUser);

    return () => {
      window.removeEventListener("userProfileUpdated", refreshUser);
      window.removeEventListener("storage", refreshUser);
    };
  }, []);

  useEffect(() => {
    setShowMore(false);
  }, [location.pathname]);

  const profilePhoto = getUploadUrl(currentUser?.profile_photo);

  const isMoreRoute = useMemo(
    () =>
      moreItems.some((item) => location.pathname.startsWith(item.to)) ||
      location.pathname.startsWith("/defaultsettings"),
    [location.pathname],
  );

  return (
    <>
      <style>
        {`
          .app-footer.clean-mobile-footer {
            height: 62px;
            min-height: 62px;
            padding: 5px 10px 6px;
            background: #ffffff !important;
            border-top: 1px solid #e6ebf2 !important;
            box-shadow: none !important;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 4px;
            z-index: 1000;
          }

          .clean-mobile-footer .footer-link,
          .clean-mobile-footer .footer-more-btn {
            width: 20%;
            min-width: 0;
            height: 50px;
            border: 0;
            background: transparent;
            border-radius: 13px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 3px;
            color: #7b8798;
            text-decoration: none;
            font-family: inherit;
            cursor: pointer;
            transition: all 0.18s ease;
          }

          .clean-mobile-footer .footer-link i,
          .clean-mobile-footer .footer-more-btn i {
            font-size: 21px;
            line-height: 1;
            color: #64748b !important;
            opacity: 1 !important;
            visibility: visible !important;
          }

          .clean-mobile-footer .footer-link span,
          .clean-mobile-footer .footer-more-btn span {
            font-size: 9px;
            line-height: 1;
            font-weight: 700;
            white-space: nowrap;
          }

          .clean-mobile-footer .footer-more-dots {
            width: 24px;
            height: 24px;
            border-radius: 9px;
            background: #eef4ff;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 2px;
          }

          .clean-mobile-footer .footer-more-dots b {
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background: #2563eb;
            display: block;
          }

          .clean-mobile-footer .footer-more-btn.active .footer-more-dots {
            background: #dbeafe;
          }

          .clean-mobile-footer .footer-link.active,
          .clean-mobile-footer .footer-more-btn.active {
            color: #2563eb;
            background: #eff6ff;
            box-shadow: none !important;
          }

          .clean-mobile-footer .footer-link.active i,
          .clean-mobile-footer .footer-more-btn.active i {
            color: #2563eb !important;
          }

          .clean-mobile-footer .footer-link.active i,
          .clean-mobile-footer .footer-more-btn.active i {
            transform: translateY(-1px);
          }

          .footer-more-overlay {
            position: fixed;
            inset: 0;
            background: rgba(15, 23, 42, 0.35);
            z-index: 1001;
            display: flex;
            align-items: flex-end;
          }

          .footer-more-sheet {
            width: 100%;
            background: #ffffff;
            border-radius: 22px 22px 0 0;
            padding: 12px 16px 82px;
            box-shadow: none;
            animation: footerSheetUp 0.18s ease;
          }

          @keyframes footerSheetUp {
            from {
              transform: translateY(18px);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }

          .footer-sheet-handle {
            width: 42px;
            height: 4px;
            border-radius: 999px;
            background: #d7dee8;
            margin: 0 auto 14px;
          }

          .footer-sheet-title {
            margin: 0 0 12px;
            color: #0f172a;
            font-size: 16px;
            font-weight: 700;
          }

          .footer-more-grid {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 10px;
          }

          .footer-more-item {
            min-height: 76px;
            border-radius: 15px;
            border: 1px solid #e7edf5;
            background: #f8fafc;
            color: #334155;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 7px;
            text-decoration: none;
            font-size: 11px;
            font-weight: 700;
          }

          .footer-more-item i {
            font-size: 22px;
            color: #2563eb;
          }

          .footer-profile-item img {
            width: 28px;
            height: 28px;
            object-fit: cover;
            border-radius: 50%;
            border: 2px solid #cbd5e1;
          }

          @media (min-width: 992px) {
            .app-footer.clean-mobile-footer,
            .footer-more-overlay {
              display: none !important;
            }
          }
        `}
      </style>

      <div className="app-footer clean-mobile-footer">
        {mainItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            aria-label={item.label}
            className={({ isActive }) =>
              `footer-link${isActive ? " active" : ""}`
            }
          >
            <i className={item.icon} />
            <span>{item.label}</span>
          </NavLink>
        ))}

        <button
          type="button"
          className={`footer-more-btn${isMoreRoute || showMore ? " active" : ""}`}
          onClick={() => setShowMore(true)}
          aria-label="More"
        >
          <span className="footer-more-dots" aria-hidden="true">
            <b></b>
            <b></b>
            <b></b>
          </span>
          <span>More</span>
        </button>
      </div>

      {showMore && (
        <div
          className="footer-more-overlay"
          onClick={() => setShowMore(false)}
        >
          <div
            className="footer-more-sheet"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="footer-sheet-handle" />
            <h4 className="footer-sheet-title">More</h4>

            <div className="footer-more-grid">
              {moreItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className="footer-more-item"
                >
                  <i className={item.icon} />
                  <span>{item.label}</span>
                </NavLink>
              ))}

              <NavLink
                to="/defaultsettings"
                className="footer-more-item footer-profile-item"
              >
                <img
                  src={profilePhoto}
                  alt="Profile"
                  onError={(event) => {
                    event.currentTarget.src = "/assets/images/user.png";
                  }}
                />
                <span>Profile</span>
              </NavLink>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Appfooter;
